import { render } from "./ListDashboardNew.vue?vue&type=template&id=0cb4cfe6"
import script from "./ListDashboardNew.vue?vue&type=script&lang=js"
export * from "./ListDashboardNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__